import DiagnosesDialog from './_DiagnosesDialog';

export default DiagnosesDialog;
